class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.main = document.querySelector('main');

    this.touchDevices = window.matchMedia('(hover: none)');
    if (this.touchDevices.matches) {
      this.mainDetailsToggle.addEventListener('click', this.onTouchClick.bind(this));
    } else {
      this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseenter.bind(this));
      this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseleave.bind(this));
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);

  }

  onTouchClick(event) {
    if(!event.target.classList.contains("mega-menu__link")){
      this.executeRedirect();
      event.preventDefault();

      this.allDetailsToggle = document.querySelectorAll("details.mega-menu");
      this.allDetailsToggle.forEach(element => {
        element.removeAttribute('nextClickRedirectToPage');
        element.removeAttribute('open');
      });

      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.removeAttribute('nextClickRedirectToPage');
        this.main.classList.remove('dark-overlay');
      } else {
        this.main.classList.add('dark-overlay');
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.setAttribute('nextClickRedirectToPage', '');
      }
    }
  }

  executeRedirect() {
    if (this.mainDetailsToggle.hasAttribute('nextClickRedirectToPage')) {
      this.url = this.mainDetailsToggle.querySelector('summary').firstElementChild.getAttribute('href');
      location.href = this.url;
    }
  }

  onMouseenter() {
    this.main.classList.add('dark-overlay');
    this.mainDetailsToggle.setAttribute('open', '');
  }

  onMouseleave() {
    this.main.classList.remove('dark-overlay');
    this.mainDetailsToggle.removeAttribute('open');
  }

}

customElements.define('header-menu', HeaderMenu);
